import { initAll } from 'govuk-frontend'

document.body.className += ' js-enabled govuk-frontend-supported'

initAll()
